import {
  parseFamilyDashboardResponse,
  parseFamilyScheduleResponse,
  parseFamilyStudentDetail,
  parseFamilyStudentsResponse
} from "@madamuh/domain";
import type {
  FamilyDashboardResponseDto,
  FamilyScheduleResponseDto,
  FamilyStudentDetailDto,
  FamilyStudentsResponseDto
} from "@madamuh/domain";
import { apiGet } from "./client";

export async function fetchFamilyDashboard(tenantSlug: string): Promise<FamilyDashboardResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/dashboard`);
  return parseFamilyDashboardResponse(response);
}

export async function fetchFamilyStudents(tenantSlug: string): Promise<FamilyStudentsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/students`);
  return parseFamilyStudentsResponse(response);
}

export async function fetchFamilyStudentDetail(
  tenantSlug: string,
  studentId: string
): Promise<FamilyStudentDetailDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/students/${studentId}`);
  return parseFamilyStudentDetail(response);
}

export async function fetchFamilySchedule(tenantSlug: string): Promise<FamilyScheduleResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/schedule`);
  return parseFamilyScheduleResponse(response);
}
